exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-card {\r\n   width: 300px;\r\n     margin: 0 auto; \r\n}\r\n\r\n.sign-in-header-image {\r\n  background-image: url('');\r\n  background-size: cover;\r\n}\r\n\r\n.accounts-header-image {\r\n  background-image: url('');\r\n  background-size: cover;\r\n}\r\n\r\n.example-full-width {\r\n  width: 100%;\r\n}\r\n\r\n.example-auto {\r\n    margin: 0 auto; \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// c:/Dev/Angular/liceo/src/app/user-auth/user-auth.component.css
// module id = ../../../../../src/app/user-auth/user-auth.component.css
// module chunks = main